<template>
  <div class="charts-container">
    <div>
      <el-row :gutter="32">
        <el-col :span="8">
          <ContentBox>
            <div class="chart-title" slot="title">
              <div class="title">数据概览</div>
            </div>
            <VePie :settings="exposurePie.settings" :data="exposurePie.data" :loading="loading" :extend="exposurePie.extend" height="300px">
              <ChartDataEmpty class="no-message" v-if="!loading && exposurePie.data.rows.length === 0" />
            </VePie>
          </ContentBox>
        </el-col>
        <el-col :span="16" style="padding-left:0">
          <ContentBox>
            <div class="chart-title" slot="title">
              <div class="title">曝光量曲线图</div>
            </div>
            <VeLine
              :data="exposureLine.data"
              :settings="exposureLine.settings"
              :extend="exposureLine.extend"
              :legend-visible="false"
              :colors="['#FF8B00']"
              :loading="loading"
              height="300px"
            >
              <ChartDataEmpty v-if="!loading && exposureLine.data.rows.length === 0" />
            </VeLine>
          </ContentBox>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row>
        <el-col>
          <ContentBox>
            <div class="download" slot="title">
              <p class="title">详细数据</p>
              <p class="title-right">
                <el-button size="mini">
                  <i class="el-icon-cc-unorderedlist" style="font-size: 12px;padding-right:4px"></i>导出
                </el-button>
              </p>
            </div>
            <Table :props="table.props" :header="header" :data="table.data" />
            <pagination
              v-bind:currentpage="currentPage"
              v-bind:pagesize="pageSize"
              v-bind:totalcount="totalCount"
              @handle-size-change="handleSizeChange"
              @handle-current-change="handleCurrentChange"
            ></pagination>
          </ContentBox>
        </el-col>
      </el-row>
      <!-- <ContentBox>
          <div class="download" slot="title">
            <p class="title">详细数据</p>
            <p class="title-right">
              <el-button size="mini">
                <i class="el-icon-cc-unorderedlist" style="font-size: 12px;padding-right:4px"></i>导出
              </el-button>
            </p>
          </div>
          <Table :props="table.props" :header="table.header" :data="table.data" />
          <pagination
            v-bind:currentpage="currentPage"
            v-bind:pagesize="pageSize"
            v-bind:totalcount="totalCount"
            @handle-size-change="handleSizeChange"
            @handle-current-change="handleCurrentChange"
          ></pagination>
      </ContentBox>-->
    </div>
  </div>
</template>
<script>
import { Table } from '@ccprivate/admin-toolkit'
import ChartDataEmpty from '@/components/ChartDataEmpty'
import VeLine from 'v-charts/lib/line.common'
import VePie from 'v-charts/lib/pie.common'
import 'v-charts/lib/style.css'
export default {
  components: {
    Table,
    VeLine,
    VePie,
    ChartDataEmpty
  },
  data() {
    return {
      // 曝光曲线图
      exposureLine: {
        data: {
          columns: ['xData', 'yData'],
          rows: []
        },
        settings: {
          labelMap: { yData: '曝光量' },
          yAxisName: ['pv']
        },
        extend: this.$consts.basicLineExtend
      },
      isShowSelect: true,
      isShowTimePicker: true,
      // 分页
      pageSize: 10,
      currentPage: 1,
      totalCount: 1,
      // 曝光量饼图
      exposurePie: {
        total: 0,
        data: {
          columns: ['xData', 'yData'],
          rows: []
        },
        settings: {
          offsetY: 90,
          label: {
            show: false,
            normal: {
              show: true,
              position: 'center',
              formatter: (event) => {
                let that = this
                let total = 1
                if (that.exposurePie.total !== 0) {
                  total = that.exposurePie.total
                }
                let percent =
                  Math.round((that.exposurePie.data.rows[0].yData / total) * 10000) /
                  100.0
                return percent + '%'
              },
              textStyle: {
                fontSize: 24,
                color: 'rgba(0, 0, 0, 0.85)'
              }
            }
          }
        },
        extend: {
          tooltip: {
            confine: true
          },
          series: {
            radius: ['50%', '65%'],
            center: ['50%', '35%']
          },
          legend: {
            bottom: 10,
            itemGap: 20,
            orient: 'vertical',
            left: 10,
            icon: 'circle',
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
              color: '#77899c',
              rich: {
                uname: {
                  width: 100
                },
                unum: {
                  // color: '#4ed139',
                  width: 40,
                  align: 'right'
                }
              }
            },
            formatter: (name) => {
              let that = this
              // let legendName = ''
              let num = 0
              if (name.indexOf('曝光量') > -1) {
                num = that.exposurePie.data.rows[0].yData
                return `{uname|曝光量}{unum|${num}}`
              } else {
                num = that.exposurePie.data.rows[1].yData
                return `{uname|待投放量}{unum|${num}}`
              }
            }
          },
          color: [
            '#FF8B00',
            '#F0F2F5',
            '#B1FC03',
            '#35FC03',
            '#FC0335',
            '#FD783F',
            '#FEA37C',
            '#03FC4E',
            '#FC03B1',
            '#7CD7FE',
            '#3FC4FD',
            '#03FCCA',
            '#CA03FC',
            '#4E03FC',
            '#0335FC',
            '#03B1FC'
          ]
        }
      },
      exposureAmount: 0,
      loading: false,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '日期',
            align: 'left',
            prop: 'statData',
            'show-overflow-tooltip': true
          },
          {
            label: '时间',
            align: 'left',
            prop: 'hour',
            'show-overflow-tooltip': true,
            formatter: (row) => {
              if (row.hour) {
                const hour = row.hour || ''
                let basic = hour.length === 1 ? '0' + hour : hour
                if (basic === '24') {
                  basic = '00'
                }
                return basic + ':00 - ' + basic + ':59'
              }
            }
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'spaceName',
            'show-overflow-tooltip': true
          },
          {
            label: '曝光量(PV)',
            align: 'right',
            prop: 'pv',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv || 0).toLocaleString()
            }
          }
        ],
        data: []
      }
    }
  },
  props: {
    scheduleChartData: {
      type: Object
    }
  },
  watch: {
    scheduleChartData: {
      handler(newValue, oldValue) {
        this.fetchData()
      },
      deep: true
    }
  },
  computed: {
    header() {
      let header = this.table.header
      if (this.scheduleChartData.showType === 0) {
        header = this.table.header.filter((item) => item.prop !== 'hour')
      } else {
        header = this.table.header
      }
      return header
    }
  },
  methods: {
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getTableData()
    },
    // 点击筛选，输出图表数据
    fetchData() {
      if (this.scheduleChartData.orderId) {
        this.loading = true
        const form = {
          orderId: this.scheduleChartData.orderId,
          scheduleId: this.scheduleChartData.scheduleId,
          showType: this.scheduleChartData.showType,
          beginDate: this.$moment(this.scheduleChartData.time[0]).format('YYYY-MM-DD'),
          endDate: this.$moment(this.scheduleChartData.time[1]).format('YYYY-MM-DD')
        }
        this.$service.getOrderBaseReport(form).then((data) => {
          this.exposureLine.data.rows = data.lineList || []
          this.exposureAmount = data.totalPv || 0
          let remain = data.totalContract - data.totalPv
          remain = remain > 0 ? remain : 0
          this.exposurePie.data.rows = [
            { xData: '曝光量', yData: data.totalPv || 0 },
            { xData: '待投放量', yData: remain }
          ]
          this.exposurePie.total = this.exposurePie.data.rows.reduce(
            (a, b) => a.yData + b.yData
          )
        })
        this.pageSize = 10
        this.currentPage = 1
        this.loading = false
        this.getTableData()
      }
    },
    getTableData() {
      const form = {
        orderId: this.scheduleChartData.orderId,
        scheduleId: this.scheduleChartData.scheduleId,
        showType: this.scheduleChartData.showType,
        beginDate: this.$moment(this.scheduleChartData.time[0]).format('YYYY-MM-DD'),
        endDate: this.$moment(this.scheduleChartData.time[1]).format('YYYY-MM-DD'),
        pageSize: this.pageSize,
        pageNo: this.currentPage
      }
      this.$service.getBasePageList(form).then((data) => {
        this.table.data = data.rows || []
        const totalCount = Number(data.total)
        this.totalCount = isNaN(totalCount) ? 0 : totalCount
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
.charts-container
  background #f2f2f2
  padding 16px 16px 0
  overflow auto
  height calc(100vh - 176px)
.download
  width 100%
  display flex
  justify-content space-between
  padding-right 20px
  align-items center
.title-right
  display flex
  align-items center
.title-right-radio
  margin-right 10px
</style>
